import { render, staticRenderFns } from "./propertyCommunityList.vue?vue&type=template&id=70a43db5&scoped=true"
import script from "./propertyCommunityList.vue?vue&type=script&lang=js"
export * from "./propertyCommunityList.vue?vue&type=script&lang=js"
import style0 from "./propertyCommunityList.vue?vue&type=style&index=0&id=70a43db5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a43db5",
  null
  
)

export default component.exports